import React from 'react';
import I18n from 'i18n-js';

import CurationActions from '../actions/curation_actions';
import CurationStore from '../stores/curation_store';
import CurationAdmin from './admin';
import { RCModal } from '@reverbdotcom/cadence/components';

class CurationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = CurationStore.getState();
    this.onCurationStoreUpdated = this.onCurationStoreUpdated.bind(this);
  }

  componentDidMount() {
    CurationStore.listen(this.onCurationStoreUpdated);
  }

  componentWillUnmount() {
    CurationStore.unlisten(this.onCurationStoreUpdated);
  }

  onCurationStoreUpdated() {
    this.setState(CurationStore.getState());
  }

  render() {
    return (
      <RCModal
        isOpen={this.state.isCurating}
        onOpenChange={(open) => { if (!open) CurationActions.stopCurating(); }}
        size="wide"
        title={I18n.t('discovery.curation.addToSet')}
        actions={{
          primary: {
            buttonText: I18n.t('discovery.curation.doneCurating'),
            onClick: CurationActions.stopCurating,
          },
          secondary: true,
        }}
      >
        <CurationAdmin />
      </RCModal>
    );
  }
}

export default CurationModal;
